(function () {
  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined && text !== null) node.textContent = text;
    return node;
  }

  function getWidgetData(productId) {
    const widgets = window.jdgm && window.jdgm.data && window.jdgm.data.reviewWidget;
    if (widgets) {
      if (widgets[productId] && Array.isArray(widgets[productId].reviews)) return widgets[productId];
      const available = Object.values(widgets).find(
        (entry) => entry && Array.isArray(entry.reviews) && entry.reviews.length
      );
      if (available) return available;
    }

    for (const script of document.querySelectorAll('.jdgm-review-widget-data')) {
      const match = script.textContent.match(/reviewWidget\[\d+\]\s*=\s*(\{[\s\S]*\})\s*;/);
      if (!match) continue;
      try {
        const data = JSON.parse(match[1]);
        if (Array.isArray(data.reviews)) return data;
      } catch (error) {
        // Judge.me can update this script while the theme editor reloads.
      }
    }
    return null;
  }

  function renderReviewGallery() {
    const section = document.querySelector('.yj-review-gallery-section');
    const mount = section && section.querySelector('.yj-review-gallery-mount');
    if (!section || !mount) return false;

    const nativeWidget = document.querySelector('.jdgm-rev-widg');
    const sourceSection = nativeWidget && nativeWidget.closest('.shopify-section');

    if (mount.querySelector('.yj-review-grid')) return true;

    const data = getWidgetData(section.dataset.productId);
    if (!data || !data.reviews.length) {
      section.classList.remove('is-ready');
      section.hidden = true;
      if (sourceSection && !sourceSection.contains(section)) {
        sourceSection.classList.remove('yj-native-review-source');
        sourceSection.style.removeProperty('display');
      }
      return false;
    }

    section.classList.add('is-ready');
    section.hidden = false;
    if (sourceSection && !sourceSection.contains(section)) {
      sourceSection.classList.add('yj-native-review-source');
      sourceSection.style.setProperty('display', 'none', 'important');
    }

    const grid = element('div', 'yj-review-grid');
    data.reviews.forEach((review) => {
      const card = element('article', 'yj-review-card');
      const media = element('div', 'yj-review-card__media');
      const image = document.createElement('img');
      const customerImage = Array.isArray(review.pictures_urls) && review.pictures_urls[0];

      image.src = customerImage || review.product_variant_image_url || data.image_url;
      image.alt = customerImage ? `Review photo by ${review.reviewer_name}` : data.product_name;
      image.loading = 'lazy';
      media.appendChild(image);

      const content = element('div', 'yj-review-card__content');
      const stars = element('div', 'yj-review-card__stars');
      stars.setAttribute('aria-label', `${review.rating} out of 5 stars`);
      stars.textContent = `${'\u2605'.repeat(review.rating)}${'\u2606'.repeat(5 - review.rating)}`;
      content.append(
        stars,
        element('p', 'yj-review-card__text', `"${review.body}"`),
        element('p', 'yj-review-card__author', `- ${review.reviewer_name}`)
      );
      card.append(media, content);
      grid.appendChild(card);
    });

    mount.appendChild(grid);
    const summary = section.querySelector('.yj-review-gallery-section__summary');
    if (summary) summary.textContent = `${data.average_rating} \u2605 | ${data.number_of_reviews} reviews`;

    return true;
  }

  function initialize() {
    renderReviewGallery();
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (renderReviewGallery() || attempts >= 120) window.clearInterval(timer);
    }, 250);
  }

  function findNativeWriteButton(root) {
    const elements = root.querySelectorAll('*');
    for (const node of elements) {
      if (node.shadowRoot) {
        const shadowButton = findNativeWriteButton(node.shadowRoot);
        if (shadowButton) return shadowButton;
      }

      const text = (node.textContent || '').trim().toLowerCase();
      const isButton = node.matches('button, a, [role="button"]');
      const isCustomButton = node.classList.contains('yj-review-gallery-section__write');
      if (isButton && !isCustomButton && text === 'write a review') return node;
    }
    return null;
  }

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.yj-review-gallery-section__write')) return;

    const nativeButton = findNativeWriteButton(document);
    if (nativeButton) nativeButton.click();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);

  const observer = new MutationObserver(renderReviewGallery);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
